import type { AdviceCard } from '../../types/adviceCards.types'

export { ORANGE_ADVICE_CARD_THEME } from '../../constants/adviceCardTheme'

/** Prefer non-empty CMS title/body when present; otherwise fall back to product defaults. */
export function resolveAdviceCardText(
  card: AdviceCard | undefined,
  defaults: Pick<AdviceCard, 'title' | 'body'>
): Pick<AdviceCard, 'title' | 'body'> {
  return {
    title: card?.title?.trim() ? card.title : defaults.title,
    body: card?.body?.trim() ? card.body : defaults.body
  }
}
